import { css } from "@emotion/react";

export const TransactionsMobilePageStyle = {
  wrapper: css`
    padding: 8px 15px;
  `,
};
